import { upperCase } from 'lodash';
import Tag from '../../components/lozenge/tags';
import ClickableTooltip from '../../components/tooltip/clickTooltip';
import { ActionButton } from '../../components/vertical-dot/popper';
// eslint-disable-next-line camelcase
import { type Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_CompanyBankListDto } from '@wealthlane/api-services/wealthlane-finance-integration-service';
import { Display } from '../style/common.styled';
import { TableBodyCellColumn, TableBodyCellColumnCenter } from '../style/table.styled';

export const BankAccountTemplatesHeader = ({
  actions,
  tableActions,
  data,
}: {
  actions?: any;
  tableActions?: any;
  // eslint-disable-next-line camelcase
  data?: Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_CompanyBankListDto[] | null;
}): any[] => {
  const getAccountNumber = (value: string): string => {
    const getSplitValue = value.split('').length;
    return value.slice(getSplitValue - 4, getSplitValue);
  };

  const getActions = (rowData: Record<string, any>): any => {
    let newActions = [];
    if (rowData.status === 'Rejected') {
      newActions = tableActions.filter(
        (item: any) => !['Set as Default Account'].includes(item.action)
      );
    } else {
      newActions = tableActions;
    }
    return newActions;
  };

  const renderCell = ({ row }: { row: any }) => {
    const show = data?.find((item) => item.id === row.original.id);
    let filterAction = [...tableActions];
    if (show?.verificationStatusId !== 0) {
      const filterData = filterAction.filter((item) => item.action !== 'Verify');
      filterAction = filterData;
    }
    return (
      <td>
        <ActionButton
          actions={getActions(row.original)}
          id={row.original.id}
          rowData={row.original}
          counter={parseInt(row?.id)}
        />
      </td>
    );
  };

  const newActions = [
    ...(actions || []),
    {
      Header: '',
      accessor: 'actions',
      width: 20,
      sortable: false,
      renderCell: true,
      isSubHeader: false,
      Cell: renderCell,
    },
  ];

  return newActions;

  return [
    {
      Header: 'Bank Account Details',
      accessor: 'accountName',
      width: 300,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumn>
            <div className='cellTitle'>
              {row.original.bankName != null && row.original.bankName !== ''
                ? row.original.bankName
                : '-'}
              <Tag
                variant='info'
                title={
                  row.original.accountName != null && row.original.accountName !== ''
                    ? row.original.accountName
                    : '-'
                }
              />
            </div>
            {/* <div className='cellSubtitle'>
              {row.original.domiciledIn != null && row.original.domiciledIn !== ''
                ? row.original.domiciledIn
                : '-'}
            </div> */}
          </TableBodyCellColumn>
        );
      },
    },
    {
      Header: 'Account Number',
      accessor: 'accountNumber',
      width: 200,
      center: true,
      sortable: false,
      Cell: ({ row }: any) => {
        return (
          <ClickableTooltip
            tooltipText={
              row.original.accountNumber != null && row.original.accountNumber !== ''
                ? row.original.accountNumber
                : 'No Data Found'
            }
            variant='dark'>
            <TableBodyCellColumnCenter>
              {row.original.accountNumber != null
                ? `XXXXXXXX${getAccountNumber(row.original.accountNumber)}`
                : '-'}
            </TableBodyCellColumnCenter>
          </ClickableTooltip>
        );
      },
    },
    {
      Header: 'Routing Number',
      accessor: 'routingNumber',
      width: 200,
      center: true,
      sortable: false,
      Cell: ({ row }: any) => {
        return (
          <Display>
            <ClickableTooltip
              tooltipText={row.original.routingNumber ?? 'No Data Found'}
              variant='dark'>
              <TableBodyCellColumnCenter>XXXXXXXXX</TableBodyCellColumnCenter>
            </ClickableTooltip>
          </Display>
        );
      },
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 200,
      center: true,
      Cell: ({ row }: any) => (
        <Display>
          {row.original.status ? (
            <Tag
              variant={
                row.original.status === 'Verified'
                  ? 'success'
                  : row.original.status === 'Pending Broker'
                    ? 'info'
                    : row.original.status === 'Broker Received'
                      ? 'primary'
                      : 'error'
              }
              title={
                row.original.status === 'Verified'
                  ? 'Verified'
                  : row.original.status === 'Pending Broker'
                    ? 'Pending'
                    : row.original.status === 'Broker Received'
                      ? 'Broker Received'
                      : row.original.status
              }
            />
          ) : (
            '-'
          )}
        </Display>
      ),
    },
    {
      Header: 'Default Account',
      accessor: 'isDefaultAccount',
      width: 200,
      center: true,
      Cell: ({ row }: any) => (
        <Display>
          {row.original.isDefaultAccount ? <Tag variant={'info'} title={'Yes'} /> : '-'}
        </Display>
      ),
    },
    {
      Header: 'Account Purpose',
      accessor: 'bankPurpose',
      width: 200,
      sortable: false,
      center: true,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumnCenter>
            {row.original.bankPurpose != null && row.original.bankPurpose !== ''
              ? row.original.bankPurpose
              : '-'}
          </TableBodyCellColumnCenter>
        );
      },
    },
    {
      Header: '',
      accessor: 'actions',
      width: 20,
      sortable: false,
      Cell: ({ row }: any) => {
        const show = data?.find((item) => item.id === row.original.id);
        let filterAction = [...tableActions];
        if (show?.verificationStatusId !== 0) {
          const filterData = filterAction.filter((item) => item.action !== 'Verify');
          filterAction = filterData;
        }

        return (
          <ActionButton
            actions={getActions(row.original)}
            id={row.original.id}
            rowData={row.original}
            counter={parseInt(row?.id)}
          />
        );
      },
    },
  ];
};
